import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import getUrl from '../utils/getUrl';

@customElement('ls-hint-modal')
export class LsHintModal extends LitElement {
    static styles = css`
        .modal {
            display: flex;
            flex-direction: column;
            gap: 20px;
            padding: 20px;
            background-color: #fff;
            border-radius: 10px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 2001;
        }

        .modal .close-icon {
            cursor: pointer;
            position: absolute;
            top: 20px;
            right: 20px;
        }

        .title {
            font-size: 20px;
            font-weight: 700;
        }

        .content {
            font-size: 14px;
        }

        .overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background-color: #00000080;
            z-index: 2000;
        }
    `;

    @property({ type: String }) title: string = '';
    @property({ type: Function }) onClose: () => void = () => {};

    render() {
        const closeIconUrl = getUrl(`assets/images/cancel-icon.webp`);
        return html`<div class="ls-hint-modal">
            <div class="overlay"></div>
            <div class="modal">
                <img src=${closeIconUrl} alt="close-icon" width="16" class="close-icon" @click=${this.onClose} />
                <div class="title">${this.title}</div>
                <div class="content">
                    <slot name="content"></slot>
                </div>
                <div class="footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>`;
    }
}
